import React, {useEffect, useState} from 'react'
import {Link} from "react-router-dom";
import './Navbar.css';
import {SidebarData} from "./SidebarData";
import logodanai from "../../../assets/img/logo_danai.svg";
import danaiWhite from "../../../assets/img/logo_danaiWhite.svg";
import infoTkb from "../../../assets/img/icon/icon-info-tkb.svg";
import LogoOjk from "../../../assets/img/logo-ojk.png";
import {postDanai} from "../../util/ajax";

import {Dialog} from 'primereact/dialog';
import Slider from "react-slick";

function Navbar() {
    const [visible, setVisible] = useState(false);
    const [sidebar, setSidebar] = useState(false)
    const [tkb90, setTkb90] = useState("-")
    const [tkb60, setTkb60] = useState("-")
    const [tkb30, setTkb30] = useState("-")
    const [tkb0, setTkb0] = useState("-")
    const [allTkb, setAllTkb] = useState([])
    const linkLogin = process.env.REACT_APP_LINK_LOGIN
    let settings = {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500
    };

    useEffect(() => {
        postDanai(process.env.REACT_APP_MOBILE_API_URL + '/p2p-mobile-api/rest/customerWeb/statistic', function (resp) {
            setTkb90(String(resp.tkb90).replace('.', ','));
            setTkb60(String(resp.tkb60).replace('.', ','));
            setTkb30(String(resp.tkb30).replace('.', ','));
            setTkb0(String(resp.tkb0).replace('.', ','));
        }, function () {

        });
    }, []);
    console.log(allTkb);

    const showSidebar = () => setSidebar(!sidebar)
    return (
        <>
            <header className="page-header background-added justify-between" style={{padding: '15px 36px 20px'}}>
                <div className="flex flex-row space-x-5">
                    <a href="/" className="ui-link ui-widget page-header-logo">
                        <picture>
                            <img src={logodanai} alt="Danai.id by PT AdiWisista"/>
                        </picture>
                    </a>
                    <a href="/" className="ui-link ui-widget page-header-logo" style={{alignSelf: 'center'}}>
                        <picture>
                            <img src={LogoOjk} alt="OJK"/>
                        </picture>
                    </a>
                </div>
                <div className="sign-in-and-register" style={{
                    padding: 0,
                    display: 'flex',
                    justifyContent: 'right',
                    gap: '1em',
                    backgroundColor: 'transparent'
                }}>
                    <div className="flex flex-row space-x-5">
                        <a href={linkLogin} className="link-as-outline-button my-2.5 w-32">
                            Masuk
                        </a>
                        <a href={linkLogin} className="link-as-button my-2.5 w-32">
                            Daftar
                        </a>
                    </div>
                    <div className="tkb-link">
                        <div className="container-tkb" onClick={() => setVisible(true)}>
                            <Slider {...settings} className="list">
                                <div className="item">
                                    <p className="gray">
                                        TKB90 <span className="blue">{tkb90}%</span>
                                        <img src={infoTkb} alt="icon-info-tkb" width="16"/>
                                    </p>
                                </div>
                                <div className="item">
                                    <p className="gray">
                                        TKB60 <span className="blue">{tkb60}%</span>
                                        <img src={infoTkb} alt="icon-info-tkb" width="16"/>
                                    </p>
                                </div>
                                <div className="item">
                                    <p className="gray">
                                        TKB30 <span className="blue">{tkb30}%</span>
                                        <img src={infoTkb} alt="icon-info-tkb" width="16"/>
                                    </p>
                                </div>
                                <div className="item">
                                    <p className="gray">
                                        TKB0 <span className="blue">{tkb0}%</span>
                                        <img src={infoTkb} alt="icon-info-tkb" width="16"/>
                                    </p>
                                </div>
                            </Slider>
                        </div>
                        <div className="buttons">
                            <button id="prev"/>
                            <button id="next"/>
                        </div>
                        <ul className="dots">
                            <li/>
                            <li/>
                            <li/>
                            <li/>
                        </ul>
                        <Dialog modal="true" closable="false" position="center center" resizable="false"
                                draggable="false" responsive="true" showEffect="fade" visible={visible}
                                style={{width: '80vw'}} onHide={() => {
                            if (!visible) return;
                            setVisible(false);
                        }}>
                            <div className="info-tkb">
                                <div className="header-tkb">
                                    <p className="title">Info TKB</p>
                                </div>
                                <div className="container-info-tkb">
                                    <ol className="list-disc">
                                        <li>
                                            <b>TKB90</b> adalah ukuran tingkat keberhasilan Penyelenggara dalam
                                            memfasilitasi penyelesaian kewajiban
                                            Pendanaan dalam jangka waktu sampai dengan 90 (sembilan puluh) hari
                                            kalender terhitung sejak jatuh tempo.
                                        </li>
                                        <li>
                                            <b>TKB60</b> adalah ukuran tingkat keberhasilan Penyelenggara dalam
                                            memfasilitasi penyelesaian kewajiban
                                            Pendanaan dalam jangka waktu sampai dengan 60 (enam puluh) hari
                                            kalender terhitung sejak jatuh tempo.
                                        </li>
                                        <li>
                                            <b>TKB30</b> adalah ukuran tingkat keberhasilan Penyelenggara dalam
                                            memfasilitasi penyelesaian kewajiban
                                            Pendanaan dalam jangka waktu sampai dengan 30 (tiga puluh) hari
                                            kalender terhitung sejak jatuh tempo.
                                        </li>
                                        <li>
                                            <b>TKB0</b> adalah ukuran tingkat keberhasilan Penyelenggara dalam
                                            memfasilitasi penyelesaian kewajiban
                                            Pendanaan dalam jangka waktu sampai dengan 0 (nol) hari kalender
                                            terhitung sejak jatuh tempo.
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </Dialog>
                    </div>
                </div>
            </header>
            <a href="#" className={`side-menu-trigger ${sidebar ? "closed" : ""}`} onClick={showSidebar}>
                <span className="menu-hide">Menu</span>
                <span></span>
            </a>
            <aside className={`side-menu ${sidebar ? "shown" : ""}`}>
                <img src={danaiWhite} alt="Danai.id by PT AdiWisista"/>
                <nav>
                    <div className={"space-y-8 py-5 px-10 grid grid-cols-2 gap-4"}>
                        {SidebarData.map((item, index) => {
                            return (
                                <div key={index} className={"w-full side-menu-item"} style={{margin: 0}}>
                                    <Link onClick={showSidebar}
                                          className={"navbar-item border-b-2 border-white px-5 rounded-lg my-auto hover:bg-danai-green transition duration-300 h-24 grid justify-center items-center justify-items-center"}
                                          to={item.path} style={{border: "1px solid #707070"}}>
                                        <img src={item.img} className="w-8" alt="logo"/>
                                        <div className={"text-md my-auto text-white"}>{item.tittle}</div>
                                    </Link>
                                </div>
                            );
                        })}
                    </div>
                </nav>
                <footer>
                    <p>© 2018 - <span className="current-year"></span> <strong>PT Adiwisista</strong>. All rights
                        reserved.</p>
                </footer>
            </aside>
        </>
    );
}

export default Navbar;
